<template>
  <div>
    <p>{{ title }}</p>
    <draggable class="inner" :list="value" group="notes" @end="handleEnd">
      <service-card-user
        class="list-group-item"
        v-for="element in value"
        :key="`${titlelc}-${element.id}`"
        :card="element"
        @editNote="editNote"
        @showNote="showNote"
      >
      </service-card-user>
    </draggable>
  </div>
</template>

<script>
// @ is an alias to /src
import { ServiceCardUser } from "./";
import draggable from "vuedraggable";
export default {
  name: "UserServiceCol",
  props: {
    value: Array,
    title: String,
    name: String,
  },
  watch: {
    value: {
      handler: function(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },
  computed: {
    titlelc() {
      return this.title.toLowerCase();
    },
  },
  components: {
    ServiceCardUser,
    draggable,
  },
  methods: {
    editNote($event) {
      this.$emit("editNote", { id: $event, name: this.name });
    },
    showNote($event) {
      this.$emit("showNote", { id: $event, name: this.name });
    },
    handleEnd() {
      this.$emit("handleEnd");
    },
  },
};
</script>
